import "./QRCodePage.css";
import ArtistMode from "./ArtistMode";

const QRCodePage = ({ nickname, sessionId }) => {
  return (
    <div className="qrcode-page">
      <div className="qrcode-shell">
        <ArtistMode sessionId={sessionId} nickname={nickname} />
      </div>
    </div>
  );
};

export default QRCodePage;
